import React, { useState, useEffect } from 'react';
import { StyleSheet, View } from 'react-native';
import { useSelector, useDispatch } from 'react-redux';
import { HeaderButtons, Item } from 'react-navigation-header-buttons';

import HeaderButton from '../../../components/HeaderButton';
import Colors from '../../../constants/Colors';
import DefaultText from '../../../components/DefaultText';
import TouchableItem from '../../../components/TouchableItem';
import TitleLogo from '../../../components/TitleLogo';

import * as relevancyActions from '../../../store/actions/relevancy';

const IncomeAbroadScreen = props => {
    const incomeAbroadData = useSelector(state => state.relevancy.incomeAbroad);
    const [incomeAbroad, setIncomeAbroad] = useState(incomeAbroadData);

    const data = useState(useSelector(state => state.relevancy));
    
    const dispatch = useDispatch();

    const selectionHandler = async (answer) => {
        setIncomeAbroad(answer);
        await dispatch(relevancyActions.setIncomeAbroad(answer));
        if (answer === false) {
        props.navigation.navigate('MaritalStatus');
    } else {
        props.navigation.navigate('IncomeAbroadTypes');
    }
    };

    const doneHandler = () => {
        if (incomeAbroad === false) {
            props.navigation.navigate('MaritalStatus');
        } else {
            props.navigation.navigate('IncomeAbroadTypes');
        }
    };

    useEffect(() => {
        if (incomeAbroadData !== '') {
        props.navigation.setOptions({
            headerRight: () =>
                <HeaderButtons HeaderButtonComponent={HeaderButton} >
                    <Item title="Save" iconName='ios-arrow-forward' onPress={doneHandler} />
                </HeaderButtons>
                
        });
    }
    }, [doneHandler]);

    return (
        <View style={styles.screen}>
            <View style={styles.questionContainer}>
                <DefaultText
                    style={styles.questionText}>
                    Did you receive any income from outside Switzerland in 2020?
                </DefaultText>
                <View style={styles.answerContainer}>
                    <TouchableItem 
                        onSelectItem={selectionHandler.bind(this, false)}
                        style={incomeAbroad === false ? styles.activeAnswer : styles.passiveAnswer}
                        >
                        <DefaultText
                            style={incomeAbroad === false ? styles.activeAnswerText : styles.passiveAnswerText}
                        >
                            No
                                </DefaultText>
                    </TouchableItem>
                    <TouchableItem 
                        onSelectItem={selectionHandler.bind(this, true)}
                        style={incomeAbroad === true ? styles.activeAnswer : styles.passiveAnswer}
                        >
                        <DefaultText
                            style={incomeAbroad === true ? styles.activeAnswerText : styles.passiveAnswerText}
                        >
                            Yes
                            </DefaultText>
                    </TouchableItem>
                </View>
            </View>
        </View>
    );
};

export const incomeAbroadScreenOptions = navigationData => {
    return {
        headerLeft: () =>
                <HeaderButtons HeaderButtonComponent={HeaderButton} >
                    <Item title="Save" iconName='ios-arrow-back' onPress={() => {
                        navigationData.navigation.goBack();
                    }} />
                </HeaderButtons>
    }
};

const styles = StyleSheet.create({
    screen: {
        flex: 1,
        backgroundColor: Colors.backColor,
        padding: 10
    },
    questionContainer: {
        flex: 1,
        justifyContent: 'center',
        padding: 10
    },  
    questionText: {
        fontFamily: 'lato-bold',
        color: Colors.darkBlue,
        fontSize: 20,
        marginBottom: 50,
    },
    answerContainer: {
        justifyContent: 'space-between',
        flexDirection: 'row',
        padding: 10
    },
    passiveAnswer: {
        borderRadius: 5,
        borderWidth: 0.5,
        borderColor: Colors.darkGreen,
        minHeight: 50,
        minWidth: 140,
        alignItems: 'center',
    },
    activeAnswer: {
        borderRadius: 5,
        borderWidth: 0.5,
        borderColor: Colors.darkGreen,
        backgroundColor: Colors.buttonGreen,
        minHeight: 50,
        minWidth: 150,
        alignItems: 'center',
    },
    logo: {
        marginBottom: '40%',
        width: 50,
        height: 50
    },
    activeAnswerText: {
        fontFamily: 'lato-bold',
        fontSize: 20,
        color: Colors.darkGreen,
    },
    passiveAnswerText: {
        fontFamily: 'lato-bold',
        fontSize: 16,
        color: Colors.darkGreen,
    },
});

export default IncomeAbroadScreen;